import { jsx as _jsx } from "react/jsx-runtime";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
const SkillsTemplate = (props) => {
    const { page } = props;
    const { contents } = page;
    const { dynamicPart } = contents;
    return (_jsx(Container, { sx: { maxWidth: "1208px !important", py: { xs: "40px", md: "64px" } }, children: _jsx(Stack, { spacing: { xs: 7.5, md: 15 }, children: dynamicPart }) }));
};
export default SkillsTemplate;
